import React, { useState } from "react";
import LoginHeader from "../components/Login/LoginHeader";
import ContinueButton from "./ContinueButton";
import { useNavigate, useLocation } from "react-router-dom";
import CreatePassword from "./PasswordPage";
import { updateUserPassword } from "../store/authSlice";
import { useDispatch } from "react-redux";

const PasswordSetUp = () => {
  const [passwordError, setPasswordError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validationErrors, setValidationErrors] = useState([]);
  const [passwordUpdateError, setPasswordUpdateError] = useState(false);
  const [passwordValidationClicked, setPasswordValidationClicked] =
    useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId || "";

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    newPassword: false,
    confirmPassword: false,
  });
  

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handlePasswordUpdate = async () => {
    setPasswordValidationClicked(true);

    let validationErrors = [];
    let validLength = newPassword.length >= 8;
    let validUppercase = /[A-Z]/.test(newPassword);
    let validNumber = /\d/.test(newPassword);
    let validCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);
    let validMatch = newPassword === confirmPassword;

    if (!validLength)
      validationErrors.push("Password must be at least 8 characters long.");
    if (!validUppercase)
      validationErrors.push(
        "Password must contain at least one uppercase letter."
      );
    if (!validNumber)
      validationErrors.push("Password must contain at least one number.");
    if (!validCharacter)
      validationErrors.push(
        "Password must contain at least one special character."
      );
    if (!validMatch) validationErrors.push("Passwords do not match.");

    if (validationErrors.length > 0) {
      setValidationErrors(validationErrors);
      setPasswordError(validationErrors.join(" "));
      return;
    }
    try {
      const result = await dispatch(
        updateUserPassword({ userId, password: newPassword })
      ).unwrap();

      if (result.success) {
        navigate("/account-confirmation", { state: { userId: result.id } });
      } else {
        setPasswordUpdateError("Password update failed.");
      }
    } catch (error) {
      setPasswordUpdateError(error.message || "Failed to update password.");
    }
  };

  return (
    <>
      <LoginHeader />
      <section className="flex flex-col items-center min-h-screen justify-center bg-white py-10 overflow-scroll px-6 mt-4 sm:mt-24">
      <header className="text-center mb-14">
          <h1 className="text-2xl font-semibold text-[#1d2639]">
            Secure Your Account
          </h1>
          <p className="text-base font-medium text-[#7e7e7e] w-full sm:w-[394px]">
            Create a strong password. You’ll use this to sign in.
          </p>
        </header>
        <main
          className="w-full flex flex-col justify-center items-center sm:max-w-md md:max-w-lg lg:max-w-xl"
          aria-labelledby="login-heading"
        >
          <CreatePassword
            newPassword={newPassword}
            setNewPassword={setNewPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            passwordVisibility={passwordVisibility}
            togglePasswordVisibility={togglePasswordVisibility}
            passwordValidationClicked={passwordValidationClicked}
            passwordError={passwordError}
            setPasswordError={setPasswordError}
            validationErrors={validationErrors}
          />
        </main>

        <ContinueButton
          onClick={handlePasswordUpdate}
          isDisabled={
            passwordError ||
            !newPassword || 
            !confirmPassword
          }
        />
      </section>
    </>
  );
};

export default PasswordSetUp;
